import React, { Context } from 'react';
import {
  Provider,
  createStoreHook,
  createDispatchHook,
  createSelectorHook,
  ReactReduxContextValue,
} from 'react-redux';
import { AnyAction, createStore } from 'redux';
import { editFormReducer } from './reducer';
import { EditFormState } from './types';

const EditFormContext: Context<ReactReduxContextValue<EditFormState, AnyAction>> =
  React.createContext(null) as unknown as Context<ReactReduxContextValue<EditFormState, AnyAction>>;

export const useEditFormStore = createStoreHook(EditFormContext);
export const useEditFormDispatch = createDispatchHook(EditFormContext);
export const useEditFormState = createSelectorHook(EditFormContext);

const contextmenuStore = createStore(editFormReducer);

interface EditFormProviderProps {
  children: JSX.Element | JSX.Element[] | string | null;
}

export function EditFormProvider({ children }: EditFormProviderProps) {
  return (
    <Provider context={EditFormContext} store={contextmenuStore}>
      {children}
    </Provider>
  );
}
